
<div class="container d-flex flex-column align-items-center justify-content-center w-100 h-100">
    <div>
        <video id="vid" width="550" height="550" autoplay="" loop muted="" playsinline="" class="" >
            <source src="/assets/video/sparky-bark.webm" type="video/webm">
        </video>
    </div>
    <div class=" d-flex flex-column align-items-center justify-content-center w-100">
        <h1>404 Not Authorized</h1>
        <p>It looks like you do not have permission to enter the system. If you feel this is incorrect, Sparky asks for you to please contact your System Administrator.</p>
    </div>
    <div class="mt-4">
        <button class="btn btn-primary" (click)="logout()">Logout</button>
    </div>
</div>